import { type MCPServerInfo } from '../../types';

const SonarqubeServer: MCPServerInfo = {
  serverId: 'SONARQUBE',
  name: 'Sonarqube',
  slug: 'sonarqube',
  description:
    'Interact with SonarQube Cloud, Server and Community build over the web API. Analyze code to identify quality and security issues.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/sonarqube:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {
      sonarqubeApiToken: {
        type: 'string',
        description: 'SonarQube API token',
        sensitive: false
      },
      sonarqubeUrl: {
        type: 'string',
        description:
          'URL of the SonarQube instance, to provide only for SonarQube Server or Community Build',
        sensitive: false
      },
      sonarqubeOrg: {
        type: 'string',
        description:
          'Organization key for SonarQube Cloud, not required for SonarQube Server or Community Build',
        sensitive: false
      }
    }
  }
};

export default SonarqubeServer;
